import styled, { createGlobalStyle } from "styled-components";
import theme from "../../../../../theme";

const DEFAULT_COLORS = ["#1E22FF", "#6366FF", "#9194FF", "#AEB0FF", "#D2D3FF"];
const CHANNEL_SELECTED_COLORS = ["#95959D", "#95959dd1", "#95959da8", "#95959d96", "#95959d6e"];
const CHANNEL_SELECTED_BIGGER_COLOR = "#1E22FF";

export const GlobalStyle = createGlobalStyle`
  .recharts-wrapper .recharts-cartesian-grid-horizontal line:nth-last-child(1),
  .recharts-wrapper .recharts-cartesian-grid-horizontal line:nth-last-child(2) {
    stroke-opacity: 0;
  }
`;

export const selectColorPalette = (index, metric, selectedChannel) => {
  if (selectedChannel && metric.name === selectedChannel) {
    return CHANNEL_SELECTED_BIGGER_COLOR;
  }

  if (selectedChannel && metric.name !== selectedChannel) {
    return CHANNEL_SELECTED_COLORS[index % DEFAULT_COLORS.length];
  }

  return DEFAULT_COLORS[index % DEFAULT_COLORS.length];
};

export const PercentageLabel = {
  fontSize: 12,
  color: theme.colors.dataViz.primaryPercentageColor
};

export const PieChartWrapper = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
  font-size: 11px;
  text-align: center;
  color: ${({ theme }) => theme.colors.dataViz.lightPercentageColor};
`;

export const TargetBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px;
  background-color: rgb(239, 241, 252);
  border-radius: 3px;
  text-align: center;
  width: inherit;
  height: inherit;
  align-items: center;
  justify-content: center;
`;

export const TargetBoxTitle = styled.div`
  color: #7a89f4;
  font-size: 11px;
`;

export const TargetBoxValue = styled.div`
  color: rgb(30, 31, 67);
  font-size: 14px;
  font-weight: 700;
`;

export const TooltipBox = styled.div`
  background: #ffffff;
  padding: 10px;
  border: 1px solid #cccccc;
`;
